/**
 * Возвращает тип переданного аргумента.
 *
 * @param {*} arg Список условий.
 * @return {string} Тип данных.
 */
export default function(arg) {
    return typeof arg;
}
